import gql from 'graphql-tag';

export default gql`
  mutation createProductSupplier($input: CreateProductSupplierInput!) {
    createProductSupplier(input: $input) {
      success
      data {
        id
        productId
        supplierId
        invoiceName
        invoiceUom
        supplierName
      }
      userErrors {
        field
        message
      }
    }
  }
`;
